import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth.service';
import { ToasterService } from '../../../services/toaster.service';
import { environment } from '../../../environments/environment';

export const AuthGuardFxn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const _authService = inject(AuthService);
  const router = inject(Router);
  const _toasterService = inject(ToasterService);
  const _translateService = inject(TranslateService);

  const token = route.queryParams['token'];
  if (token) {
    sessionStorage.setItem(environment.storageKey, token);
  }
  if (!_authService.isAuthenticated()) {
    if (state.url.includes('auth')) {
      return true;
    }
    router.navigate(['/auth/login']);
    _toasterService.errToastr(_translateService.instant('LoginFirst'));
    return false;
  } else {
    if (state.url.includes('auth')) {
      router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
};
